var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"MJ Code logo","src":require("../assets/images/mjcode-logo.png")}}),_c('VueHelloWorld',{attrs:{"msg":"Welcome to Your Vue.js + TypeScript App"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }